export default {"src":"/_next/static/media/logo.8a30d946.svg","height":100,"width":100};